import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { downloadFile, getLongDate, getStringDate } from 'src/app/common/util';
import { CompanyRoleResponse } from 'src/app/models/company.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { CompanyService } from 'src/app/services/company.service';
import { UserSaved } from 'src/app/models/user.model';
import { InputAutocompleteModel } from 'src/app/models/input-autocomplete.model';
import { HttpErrorResponse } from '@angular/common/http';
import { AdminDteReportService } from 'src/app/services/reports/admin-dte-report.service';

@Component({
  selector: 'app-reconciliation-report',
  templateUrl: './reconciliation-report.component.html',
  styleUrls: ['./reconciliation-report.component.scss']
})
export class ReconciliationReportComponent implements OnInit{
  selectedReport = 0;
  timeout = null;
  allCompanies = [];
  companies = [];
  user: UserSaved = null;
  selected = null;
  inputCompany = new InputAutocompleteModel("", false, false, "", "", "", "", [], []);
  startDate = "";
  endDate = "";
  loading = true;

  constructor(
    private toastService: ToastrService,
    private authService: AuthenticationService,
    private companyService: CompanyService,
    private adminDteReportService: AdminDteReportService
  ) {
    this.companies = JSON.parse(this.authService.getCurrentUser()).companyRoles;
    this.user = this.authService.getUser();
    this.allCompanies = this.companies;
    var today = new Date();
    this.endDate = today.toLocaleDateString('en-CA');
    today.setDate(1);
    this.startDate = today.toLocaleDateString('en-CA');
  }

  ngOnInit(): void {
    if (this.user.contadorGT) {
      this.getAssociatedCompanies();
    }
  }

  getAssociatedCompanies() {
    this.companyService.getCompaniesAssociatedToPartner(this.user.id).subscribe({
      next: (response: ResponseObject) => {
        this.companies = response.data;
        this.allCompanies = this.companies;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener las companias asociadas");
      }
    })
  }
  
  searchCompany() {
    clearTimeout(this.timeout);
    this.inputCompany.class = "typing";
    this.selected = null;
    this.timeout = setTimeout(() => {
      this.companies = this.allCompanies.filter((company) => {
        var val = this.inputCompany.value.toLowerCase();
        return company.alphanumericId.toLowerCase() == val || company.companyName?.toLowerCase().includes(val) || company.companyNIT?.toLowerCase().includes(val)
        || company.name?.toLowerCase().includes(val) || company.nit?.toLowerCase().includes(val);
      });
      this.inputCompany.verified = false;
      if (this.companies.length > 0) {
        this.inputCompany.class = "fa-list";
      } else {
        this.inputCompany.class = "fa-xmark";
      }
      if (!this.inputCompany.value.toLowerCase()) {
        this.selected = null;
      }
    }, 300);
  }
    
  selectCompany(selected: CompanyRoleResponse) {
      clearTimeout(this.timeout);
      this.inputCompany.value = selected.alphanumericId + " - " + selected.companyNIT + " - " + selected.companyName;
      this.inputCompany.verified = true;
      this.inputCompany.class = "fa-circle-check";
      this.selected = selected;
    }

  getReconciliationReport(type: string) {
    if (!this.startDate || !this.endDate) {
      this.toastService.error("Debe seleccionar fecha inicial y final.");
      return;
    }
    this.loading = false;
    //var companyId = this.selected ? this.selected.companyId : null;
    // si es null traer todas las companies
    this.adminDteReportService.getReconciliationReportAllCompanies(getLongDate(this.startDate),getLongDate(this.endDate), type).subscribe({
      next: (response: ResponseObject) => {
        if (type == 'json') {
          // logica para mostrar
        } else {
          downloadFile(response.data, type, 'Reporte de Reconciliación XML '); // TODO: Agregar company
          this.toastService.success("Se ha descargado correctamente el reporte de Reporte de Reconciliación XML");
        }
        this.loading = true;
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener el reporte de Reporte de Reconciliación XML");
        this.loading = true;
      }
    })
  }
}
